<div class="home">
  <img src="assets/images/background-house-1.svg" class="background-big"/>
  <img src="assets/images/background-house-2.svg" class="background-small"/>

 <ng-content></ng-content>
</div>

